export const BASE_JIRA_URL = '/rest/api/3/';

const Routes = {
  // Jira API routes
  GET_ISSUES_COUNT: 'search/jql',
  LOAD_EPICS: 'search/jql',
  SEARCH: 'search/jql',
  GET_RECENT_PROJECT: 'project/recent',
  BULK_CREATE_ISSUES: 'issue/bulk',
  GET_PROJECT: 'project', // URL -> 'project/{projectIdOrKey}'
  GET_ISSUE_TYPES: 'issuetype/project', // GET /rest/api/3/issuetype/project?projectId={id}
  
  // AI Provider endpoints
  OPENAI_COMPLETIONS: 'https://api.openai.com/v1/chat/completions',
  ANTHROPIC_MESSAGES: 'https://api.anthropic.com/v1/messages',
  GOOGLE_GENERATE: 'https://generativelanguage.googleapis.com/v1beta/models',
  XAI_COMPLETIONS: 'https://api.x.ai/v1/chat/completions',
  
  // Legacy routes (kept for backward compatibility)
  // These still work but internally route through AIProviderFactory when needed
  GENERATE_ENHANCE_PROMPT: 'https://api.openai.com/v1/chat/completions',
  GENERATE_ISSUES: 'https://api.openai.com/v1/chat/completions'
};
export default Routes;
